import { render, staticRenderFns } from "./ParceriaIDEC.vue?vue&type=template&id=4aa69248&"
import script from "./ParceriaIDEC.vue?vue&type=script&lang=js&"
export * from "./ParceriaIDEC.vue?vue&type=script&lang=js&"
import style0 from "./ParceriaIDEC.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports